import InputWrapper from "./components/InputWrapper";
import {Link, useParams} from "react-router-dom";
import GoBack from "./components/GoBack";
import {useForm} from "react-hook-form";
import {useState} from "react";
import Meta from "../components/Meta";
import PasswordRequirements from "../components/PasswordRequirements";
import Data from "./Data";

const ResetPassword = () => {
    const { token } = useParams()

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false)
    const [success, setSuccess] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const { register, handleSubmit, formState: { errors }, watch } = useForm()

    const submit = async (data) => {
        setLoading(true)
        setSuccess(false)

        try {
            await Data.resetPassword(data.email, data.password, token)

            setLoading(false)
            setError(false)
            setSuccess(true)
            setErrorMessage('')
        } catch(error) {
            setErrorMessage(error?.response?.data?.message || '')
            setLoading(false)
            setError(true)
            setSuccess(false)
        }
    }

    return (
        <>
            <Meta title={'Reset Password'} />
            <GoBack to={"/"} label={"Back to Home"} />
            {!success ?
                <form className={"w-96 mx-auto py-40 px-4 grid grid-cols-1 gap-4 rounded-lg"} onSubmit={handleSubmit(submit)}>
                    <h1>Reset Password</h1>
                    <InputWrapper label={"Email Address"} input={<input type={"text"} {...register("email", { required: true })} />} error={errors.email?.type === "required" ? 'This field is required' : null} />
                    <InputWrapper label={"New Password"} input={
                        <>
                            <input type={"password"} {...register("password", { required: true })} />
                            <PasswordRequirements password={watch('password') || ''} />
                        </>
                    } error={errors.password?.type === "required" ? 'This field is required' : null} />
                    <button type={"submit"} disabled={loading}
                            className={"inline-block bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md mt-2 border-0"}>{loading ? '...' : 'Set Password'}</button>
                    {error && <p className={"text-red-500"}>{errorMessage ? errorMessage : 'There was an error, please try again.'}</p>}
                    <Link className={"text-sm text-textGrey"} to={"/login"}>Remember your password?</Link>
                </form>
            :
                <div className={"w-96 mx-auto py-40 px-4 grid grid-cols-1 gap-4 rounded-lg"}>
                    <h1>Reset Password</h1>
                    <p className={"text-textGrey"}>Your password has been successfully reset. Login using the link below.</p>
                    <Link className={"inline-block bg-primary py-2 px-4 w-full lg:w-auto text-white text-center rounded-md mt-2 border-0"} to={"/login"}>Login</Link>
                </div>
            }
        </>
    )
}

export default ResetPassword